import {
  ON_ERROR,
  CLEAR_ERROR,
  ON_RECEIVE_COUNT,
  ON_RECEIVE_HAS_MORE,
} from './action_types';

export const onError = payload => ({ type: ON_ERROR, payload });
export const clearError = () => ({ type: CLEAR_ERROR });
export const onReceiveCount = payload => ({ type: ON_RECEIVE_COUNT, payload });
export const onReceiveHasMore = payload => ({ type: ON_RECEIVE_HAS_MORE, payload });



// WEBPACK FOOTER //
// ./src/modules/app_state/actions.js